import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IEmp } from '../../models/emp';
import { throwError } from '../helper';

/*
 * Book Group
 */

export const getBookGroupList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/book/book-group?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const registerBookGroup = (data: any) =>
  xapi.post(`/admin/v1/apis/book/book-group`, data).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

export const deleteBookGroup = (data: any) =>
  xapi.put('/admin/v1/apis/book/book-group/delete', data).then(res => {
    if (res.status !== 200) throwError(res.status);
    return res.data;
  });

/*
 * Book Group Category
 */
export const getBookGroupCategoryList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/book/book-group-category?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getBookGroupCategoryImageList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/book/book-group-category-image?categorySeq=${data.categorySeq}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

/*
 * Book
 */
export const getBookInfoList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/book/book-group/${data.bookGroupSeq}/book-info?page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });
